import { getSmokePoints } from '../smoke/smokeData';

const SMOKE_VIEW_EVENTS = ['moveend', 'zoomend', 'resize'];

// 主监控与烟感页面共享建筑入口，不加入联网单位统计或触发单位详情查询。
export default {
  props: {
    smokeBuildings: {
      type: Array,
      default: null
    }
  },
  data () {
    return { smokeLayers: [], hoveredSmokePointId: null, hideSmokeLabelTimer: null };
  },
  methods: {
    bindSmokeBuildingEvents () {
      SMOKE_VIEW_EVENTS.forEach(eventName => this.bindMapEvent(this.map, eventName, this.updateSmokeVisibility));
    },
    clearSmokeLayers () {
      clearTimeout(this.hideSmokeLabelTimer);
      this.hideSmokeLabelTimer = null;
      this.hoveredSmokePointId = null;
      this.smokeLayers.forEach(layer => {
        // 单位刷新可能已清理覆盖物，只移除仍由地图持有的烟感图层。
        if (this.markerLayers.includes(layer)) this.map.removeLayer(layer);
      });
      this.markerLayers = this.markerLayers.filter(layer => !this.smokeLayers.includes(layer));
      this.smokeLayers = [];
    },
    // 使用刷新总览计算出的缩放门槛；首屏可见，缩小到街道范围以外时隐藏。
    updateSmokeVisibility () {
      if (!this.isMapReady()) return;
      const visible = this.map.getZoom() >= this.labelOverviewZoom;
      if (!visible) {
        clearTimeout(this.hideSmokeLabelTimer);
        this.hideSmokeLabelTimer = null;
        this.hoveredSmokePointId = null;
      }
      this.smokeLayers.forEach(layer => {
        const element = layer.getElement();
        // 总览按悬浮显示名称，近景或选中点保持显示，避免所有地址铺满地图。
        const isLabel = layer.hm_smokeLabel;
        const showLabel = this.map.getZoom() > this.labelOverviewZoom ||
          layer.hm_smokePointId === this.currentDw || layer.hm_smokePointId === this.hoveredSmokePointId;
        element.style.display = visible && (!isLabel || showLabel) ? '' : 'none';
      });
      this.scheduleAutoUnitLabels();
    },
    drawSmokeBuildings () {
      this.clearSmokeLayers();
      // 白鹤洞主图同时保留单位点；烟感页面仍按自己的筛选范围绘制。
      const buildings = this.smokeBuildings !== null ? this.smokeBuildings
        : (this.isBaihedongOverview() ? getSmokePoints() : []);
      buildings.forEach(building => {
        const selected = this.currentDw === building.id;
        // 烟感采用青绿色单层房屋和独立探测器角标；选中时仅小幅放大。
        const width = selected ? 48 : 40;
        const height = selected ? 60 : 50;
        const title = `${building.name} · 烟感 ${building.deviceCount}`;
        const escapedTitle = document.createElement('span');
        escapedTitle.textContent = title;
        const marker = this.addMapMarker({ ...building, code: building.id }, {
          width,
          height,
          anchorY: height * 0.95,
          url: '/monitor/images/bdmap/marker_smoke_building.svg'
        }, {
          content: escapedTitle.innerHTML,
          fontSize: 14,
          color: '#e5f3fa',
          offsetWidth: this.getLabelOffsetWidth(title, 14),
          offsetHeight: -height - 28
        });
        if (!marker) return;
        this.smokeLayers.push(marker, marker.hm_label);
        // 点位名称独立控制显隐，不叠加普通单位的悬浮与自动名称。
        marker.hm_label.hm_smokeLabel = true;
        marker.hm_label.hm_smokePointId = building.id;
        marker.hm_marker = false;
        marker.hm_mouseover = 'none';
        // 主图携带点位进入烟感页，烟感页以相同事件选择对应设备组。
        this.bindMapEvent(marker, 'click', () => this.$emit('smoke-click', building.id));
        const labelElement = marker.hm_label.getElement();
        // 复用自动单位名称的字号、底衬和内边距，清除通用选中标签的行内样式。
        labelElement.classList.replace('tianditu-map-label', 'tianditu-auto-unit-label');
        ['color', 'font-size', 'line-height', 'border', 'padding'].forEach(property => labelElement.style.removeProperty(property));
        // 按标签实际尺寸居中，与图标顶部保留同自动名称一致的 10px 间距。
        marker.hm_label.setOffset(this.getTiandituLabelOffset(
          -labelElement.offsetWidth / 2, -height * 0.95 - labelElement.offsetHeight - 10
        ));
        labelElement.style.pointerEvents = 'auto';
        labelElement.style.cursor = 'pointer';
        this.bindMapEvent(marker.hm_label, 'click', () => this.$emit('smoke-click', building.id));
        // 图标和名称共享悬浮态；短暂延迟覆盖两者间的空隙，保留名称点击入口。
        [marker, marker.hm_label].forEach(layer => {
          this.bindMapEvent(layer, 'mouseover', () => {
            clearTimeout(this.hideSmokeLabelTimer);
            this.hideSmokeLabelTimer = null;
            this.hoveredSmokePointId = building.id;
            this.updateSmokeVisibility();
          });
          this.bindMapEvent(layer, 'mouseout', () => {
            clearTimeout(this.hideSmokeLabelTimer);
            this.hideSmokeLabelTimer = setTimeout(() => {
              this.hideSmokeLabelTimer = null;
              if (this.hoveredSmokePointId === building.id) this.hoveredSmokePointId = null;
              this.updateSmokeVisibility();
            }, 150);
          });
        });
      });
      this.updateSmokeVisibility();
    },
    // 按资料坐标定位设备组，原公寓房间仍共用楼宇锚点，不虚构室内位置。
    focusSmokeBuilding (building) {
      if (!this.isMapReady()) return;
      clearTimeout(this.resetMapTimer);
      this.resetMapTimer = null;
      this.currentDw = building.id;
      // 下钻幅度取街道总览到原近景级别的一半，整数级别向总览侧取整，保留周边道路。
      const zoom = Math.floor((this.labelOverviewZoom + 18) / 2);
      const position = { ...building, zoom };
      if (!this.isSamePosition(this.currentPosition, position)) this.flyTo(position);
      this.drawSmokeBuildings();
      this.scheduleBaihedongUpdate();
      this.$emit('building-select', building.id);
    },
    resetSmokeOverview () {
      if (!this.isMapReady()) return;
      this.currentDw = null;
      this.resetMap();
      this.drawSmokeBuildings();
    }
  },
  watch: {
    smokeBuildings (buildings) {
      if (!this.isMapReady()) return;
      // 筛选移除建筑时同步退出选中态，但不因筛选自动改变地图视野。
      if (!buildings.some(building => building.id === this.currentDw)) this.currentDw = null;
      this.drawSmokeBuildings();
      this.scheduleBaihedongUpdate();
    }
  },
  beforeDestroy () {
    if (this.map) {
      SMOKE_VIEW_EVENTS.forEach(eventName => this.map.removeEventListener(eventName, this.updateSmokeVisibility));
      this.clearSmokeLayers();
    }
  }
};
